module.exports = __webpack_public_path__ + "static/image1-8e64580fd17114cc40b40bdafa4478a3.jpg";